<div class="m-16">
  <app-form-base [config]="formConfig" (formSubmitted)="onFormSubmitted($event)"></app-form-base>
</div>
